import { render } from "./VerticalGap.vue?vue&type=template&id=5715cf20&scoped=true"
const script = {}

import "./VerticalGap.vue?vue&type=style&index=0&id=5715cf20&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5715cf20"]])

export default __exports__